/**
 * 🌙 The light/dark choice for /explore, /marketplace and the build form
 * (09-30, Nina: "by default users are in dark mode").
 *
 * Dark unless this device chose light with the switch. Only a press of the
 * switch writes a choice. The old key, 'explore_dark_mode', was written on
 * every visit, so it also holds '0' for people who never chose light (before
 * Nina's 08-14 dark ruling the default followed the device's own theme), and it
 * is no longer read: everyone starts in dark once, and a light choice made
 * from now on sticks.
 */
export const THEME_KEY = 'theme_choice';

const store = (storage) => (storage !== undefined ? storage : window.localStorage);

export function prefersDark(storage) {
  try { return store(storage).getItem(THEME_KEY) !== 'light'; } catch (e) { return true; }
}

export function chooseTheme(dark, storage) {
  try { store(storage).setItem(THEME_KEY, dark ? 'dark' : 'light'); } catch (e) { /* private mode: this visit only */ }
}
